export function toFieldString(value: unknown): string {
  return typeof value === "string" ? value : "";
}

export function notifyFieldChange(
  onChange: ((value: any) => void) | undefined,
  nextValue: string,
  options?: { name?: string; asEvent?: boolean },
) {
  if (!onChange) {
    return;
  }

  if (options?.asEvent) {
    onChange({
      target: { name: options.name, value: nextValue },
    });
    return;
  }

  onChange(nextValue);
}

export function insertEmojiAtCursor(
  currentValue: unknown,
  emoji: string,
  selectionStart: number | null,
  selectionEnd: number | null,
): { value: string; cursorPosition: number } {
  const normalizedValue = toFieldString(currentValue);
  const start = selectionStart ?? normalizedValue.length;
  const end = selectionEnd ?? normalizedValue.length;
  const value =
    normalizedValue.slice(0, start) + emoji + normalizedValue.slice(end);
  const cursorPosition = start + emoji.length;

  return { value, cursorPosition };
}
